import { render, staticRenderFns } from "./SithMesStoolPoCpmEdit.vue?vue&type=template&id=52f96d8e&"
import script from "./SithMesStoolPoCpmEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPoCpmEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports